import type {
  FormattedMemberPromotion,
  FormattedMemberPromotions
} from '@library/types/members/memberPromotions';
import { MemberPromotionsRow } from '@bo-components/members/memberPromotions';

export interface MemberPromotionRowsProps {
  memberPromotions: FormattedMemberPromotions;
}

const getPromotionRows = (memberPromotion: FormattedMemberPromotion) => {
  if (memberPromotion.promotionUsersDetails?.length) {
    return memberPromotion.promotionUsersDetails.map((detail) => {
      const promotionForRow: FormattedMemberPromotion = {
        ...memberPromotion,
        optedInAtDate: detail.optedInAtDate,
        optedInAtTime: detail.optedInAtTime,
        redeemedAtDate: detail.redeemedAtDate,
        redeemedAtTime: detail.redeemedAtTime
      };

      return (
        <MemberPromotionsRow
          key={`member-promotion-${promotionForRow.promotionId}-${detail.id}`}
          memberPromotion={promotionForRow}
        />
      );
    });
  }

  return (
    <MemberPromotionsRow
      key={`member-promotion-${memberPromotion.promotionId}`}
      memberPromotion={memberPromotion}
    />
  );
};

export const MemberPromotionRows = ({
  memberPromotions
}: MemberPromotionRowsProps) => (
  <>{memberPromotions.flatMap(getPromotionRows)}</>
);
